export const EN_TRANSLATION = {
  validation: {
    default: {
      email: 'Invalid email',
      required: 'This field is required',
      invalidEmailOrPassword: 'Invalid email address or password',
      invalidUserNameOrPassword: 'Invalid username or password'
    },
    loginForm: {
      emailField: {
        email: 'Please enter a valid email',
        required: 'Please enter a valid email'
      },
      passwordField: {
        required: 'Please enter your password'
      },
      userNameField: {
        required: 'Please enter a username'
      }
    }
  },
  messages: {
    generalErrorMsg: 'Something went wrong, please try again later',
    pageNotFoundMsg: 'Page is not found',
    invalidUserNameOrPasswordMsg: 'Invalid username or password'
  },
  actions: {
    goBack: 'Go back',
    reloadPage: 'Reload page'
  },
  states: {
    noData: 'No data'
  },
  cardUnits: {
    persons: 'person(s)',
    rank: '',
    store: 'store(s)',
    booking: 'booking(s)',
    yen: '￥',
    reserve: 'reserve',
    delivery: 'delivery',
    takeOut: 'take-out'
  },
  cardElements: {
    lastWeekComparison: 'Last week comparison',
    lastMonthComparison: 'Last month comparison',
    averageSales: 'Average sales',
    averagePublicVideos: 'Average number of released public videos'
  },
  mainToolbar: {
    welcomeTxt: 'Welcome',
    switchStoreBtn: 'Switch Store',
    notificationBtn: 'Notice',
    storePageDisplayBtn: 'Store Display',
    helpBtn: 'Help',
    logoutBtn: 'Log out'
  },
  leftSidebar: {
    homeMenuLabel: 'Home',
    storeInfoMenuLabel: 'Store Information',
    menusMenuLabel: 'Menus',
    liveDeliveryMenuLabel: 'LIVE',
    videoManagementMenuLabel: 'Videos Management',
    videoRequestMenuLabel: 'Videos Requests',
    externalToolSettingsMenuLabel: 'External Tool Setting',
    analysisMenuLabel: 'Analysis',
    userInfoMenuLabel: 'User Information',
    settingsMenuLabel: 'Settings'
  },
  auth: {
    login: 'Login',
    rememberMe: 'Remember me',
    emailLabel: 'Email',
    passwordLabel: 'Password',
    userNameLabel: 'Username'
  },
  dashboard: {
    numberOfStoresFollowerLabel: 'Number of stores followers',
    numberOfAccessLast30Days: 'Number of accesses last 30 days',
    categorySalesRanking: 'Sales ranking of category',
    popularStoreTrend: 'Trend of popular stores',
    customerSalesWithVideoDelivery: 'Customer sales with video / delivery',
    numberOfVideoViews: 'Number of video views',
    overallRanking: 'Overall ranking',
    categoryRaking: 'Category ranking'
  },
  liveStream: {
    pageTitle: 'LIVE Distribution Basic Settings',
    cameraListTitle: 'LIVE Delivery Cameras',
    publishingSettings: 'Publishing Settings',
    public: 'Public',
    private: 'Private',
    liveTime: 'Delivery Time',
    businessHoursOnly: 'Business Hours Only',
    specificTime: 'Specific Time',
    allDay: 'All Day',
    save: 'Save',
    stopLiveStream: 'Stop LIVE',
    startLiveStream: 'Start LIVE',
    numberOfViewers: 'Number of Viewers',
    currentViewers: 'Current',
    totalViewers: 'Total',
    man: 'person',
    onAir: 'ON AIR',
    off: 'OFF',
    audienceRanking: 'Audience Rank',
    rank: 'Rank',
    shop: 'Shop',
    numberOfViews: 'Number of views'
  },
  menuPage: {
    menuListTabLabel: 'Menu List',
    menuEditTabLabel: 'Add Menu',
    menuRegistration: 'Menu Registration',
    menuName: 'Name',
    pleaseEnter: 'Please enter',
    price: 'Price',
    description: 'Description',
    video: 'Video',
    images: 'Images',
    selectFile: 'Selected File',
    videoFileTypeMsg: 'MP4, MP4, MOV up to 10MB.',
    videoFileCountLimitMsg: 'You can upload more than',
    allergens: 'Allergic substains',
    publicSettings: 'Public setting',
    public: 'Public',
    private: 'Private',
    tag: 'Tag',
    tagNote: 'Menus with the "Our Recommended" tag are displayed at the top of the menu screen. If there are more than one, they will be displayed so that you can slide them sideways for viewing.',
    category: 'Category',
    save: 'Save',
    requiredMessage: 'REQUIRED'
  }
}
